import { Component, OnInit } from "@angular/core";
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  ValidatorFn,
  Validators,
} from "@angular/forms";
import { MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { TruckOwnerService } from "../truck-owner.service";
import { environment } from "src/environments/environment.prod";

@Component({
  selector: "app-transporter-login",
  templateUrl: "./transporter-login.component.html",
  styleUrls: ["./transporter-login.component.css"],
})
export class TransporterLoginComponent implements OnInit {
  login: boolean = true;
  otp: boolean = false;
  signUp: boolean = false;
  gst: boolean = false;
  bank: boolean = false;
  profileImg: boolean = true;
  mobile: any;
  loginForm: FormGroup;
  signupForm: FormGroup;
  otpForm: FormGroup;
  GSTForm: FormGroup;
  bankForm: FormGroup;
  loginResponse: any;
  verifyData: any;
  errorMessage: any;
  code: any;
  otpWrongErrorMsg: boolean = false;
  file: any = "";
  profileImage: any = "";
  chequeImage: any = "";
  chequeImg: boolean = true;
  token: any;
  loading: boolean = false;
  isGstVerifying: boolean = false;
  isGstVerified: boolean = false;
  gstVerificationData: any = null;
  isPanVerifying: boolean = false;
  isPanVerified: boolean = false;
  panVerificationData: any = null;
  seconds: any;
  TIME_LIMIT = 30;
  timePassed = 0;
  timeLeft = this.TIME_LIMIT;
  clearTimeInterval: any;

  COLOR_CODES = {
    info: {
      color: "green",
    },
  };
  retrieve_acc: boolean = false;
  message: any;
  response_code: boolean = false;

  constructor(
    private matDialogref: MatDialogRef<TransporterLoginComponent>,
    private formBuilder: FormBuilder,
    private snackBar: MatSnackBar,
    private services: TruckOwnerService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.token = sessionStorage.getItem("to_token");
    this.loginForm = this.formBuilder.group({
      mobile: new FormControl(
        null,
        Validators.compose([
          Validators.required,
          Validators.pattern("^[0-9]{4,10}$"),
        ])
      ),
    });
    this.signupForm = this.formBuilder.group({
      username: [
        "",
        Validators.compose([
          Validators.required,
          Validators.pattern("^[a-zA-Z][a-zA-Z\\s]+$"),
        ]),
      ],
      mobile: new FormControl(null, Validators.compose([Validators.required])),
      email: [
        "",
        Validators.compose([
          Validators.pattern(/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/),
        ]),
      ],
    });
    this.otpForm = this.formBuilder.group({
      code: [
        "",
        Validators.compose([
          Validators.required,
          Validators.pattern(/^\d{6}$/),
        ]),
      ],
    });
    this.GSTForm = this.formBuilder.group({
      gst: ["", Validators.compose([Validators.pattern("[A-Z0-9]{15}")])],

      designation: [""],
      company_name: [
        "",
        Validators.compose([
          Validators.pattern(/^[a-zA-Z0-9\s]+$/),
        ]),
      ],
      pan: ["", Validators.compose([Validators.pattern("^[a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}$")])],
      profile_pic: [""],
    });
    this.bankForm = this.formBuilder.group({
      account_name: ["", Validators.required],
      accountr_number: ["", Validators.compose([Validators.required, Validators.pattern("^[0-9]*$")])],
      ifsc_code: ["", Validators.required],
      bank_name: ["", Validators.required],
      branch_name: ["", Validators.required],
      cancelled_cheque: ["", Validators.required],
    });
  }

  verifyToken() {
    const tokenDummy = sessionStorage.getItem("to_token");

    if (tokenDummy) {
      // If the token exists (not null, undefined, or an empty string)
      this.snackBar.open("You are already logged in", "Ok", {
        duration: 5000,
      });
      return; // Stop the sendOTP function from proceeding
    }
  }

  sendOTP() {
    // this.verifyToken();
    if (this.loginForm.valid) {
      const loginData = {
        mobile: this.loginForm.value.mobile,
        user_type: "truckowner",
      };
      if (environment.base_url === `${environment.base_url}`) {
        this.response_code = true;
      } else {
        this.response_code = false;
      }
      this.loading = true;
      this.services.transporterLogin(loginData).subscribe(
        (response: any) => {
          this.loginResponse = response;
          this.login = false;
          this.otp = true;
          this.loading = true;
        },
        (error) => {
          if (error.status == 406) {
            this.snackBar.open(error.error.message, "Fail", {
              duration: 5000,
            });
            this.matDialogref.close();
          } else {
            if (error.error?.data?.new_user == true) {
              this.login = false;
              this.otp = true;
              this.loading = true;
              this.loginResponse = error.error.data;
            } else {
              this.message = error.error.message;
              this.retrieve_acc = true;
              this.login = false;
              this.otp = false;
              this.loading = false;
              this.snackBar.open(error.error.message, "Fail", {
                duration: 5000,
              });
            }
          }
        }
      );
    } else {
      this.loginForm.markAllAsTouched();
      this.snackBar.open("Please Enter Valid Mobile Number", "Fail", { duration: 5000 });
    }
  }

  clear() {
    this.matDialogref.close();
  }

  verifyOtp(code: string) {
    const otpObj = {
      code: code,
      mobile: this.loginResponse.mobile,
      user_type: "truckowner",
    };
    this.services.OTPVerify(otpObj, this.loginResponse._id).subscribe(
      (response: any) => {
        this.verifyData = response.data;
        this.errorMessage = response.message;
        if (response.auth) {
          this.token = response.auth;
        }
        if (this.verifyData.new_user == true) {
          this.login = false;
          this.otp = false;
          this.signUp = true;
          this.snackBar.open(this.errorMessage, "Info", {
            duration: 5000,
          });
          error: (e: any) => {
            this.snackBar.open(e.error.message, "Fail", {
              duration: 5000,
            });
            this.loading = false;
          };
        } else {
          this.login = false;
          this.otp = false;
          sessionStorage.setItem("to_token", response.auth);
          this.matDialogref.close();
          this.snackBar.open("Login Successful", "Success", {
            duration: 5000,
          });

          this.router.navigate(["transporter/trucks"]);
        }
      },
      (error) => {
        if (error.status == 400) {
          this.otpWrongErrorMsg = true;
        }
        if (error.status == 406) {
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      }
    );
  }
  Register(num: number) {
    if (num !== 2 && !this.chequeImage) {
      this.snackBar.open("Please upload cancelled cheque", "Fail", { duration: 5000 });
      return;
    }
    if (this.bankForm.valid) {
      let registerObj = null;
      if (num === 2) {
        registerObj = {
          username: this.signupForm.value.username,
          mobile: this.signupForm.value.mobile,
          email: this.signupForm.value.email,
          company_name: this.GSTForm.value.company_name,
          gst: (this.GSTForm.value.gst || "").trim().toUpperCase(),
          gst_verified: !!this.isGstVerified,
          designation: this.GSTForm.value.designation,
          pan: (this.GSTForm.value.pan || "").trim().toUpperCase(),
          pan_verified: !!this.isPanVerified,
          profile_pic: this.profileImage,
        };
      } else {
        if (this.bankForm.valid) {
          const accountNumber = this.bankForm.value.accountr_number;
          if (accountNumber && accountNumber.length < 8) {
            this.snackBar.open("Please enter a valid account number", "Fail", {
              duration: 5000,
            });
            return; // Exit if the account number is invalid
          }
        }
        if (this.bankForm.valid) {
          const ifscCode = this.bankForm.value.ifsc_code;
          if (ifscCode && ifscCode.length < 11) {
            this.snackBar.open("Please enter a valid ifsc code", "Fail", {
              duration: 5000,
            });
            return; // Exit if the account number is invalid
          }
        }
        let bankObj = {
          account_name: this.bankForm.value.account_name,
          accountr_number: this.bankForm.value.accountr_number,
          ifsc_code: this.bankForm.value.ifsc_code,
          bank_name: this.bankForm.value.bank_name,
          branch_name: this.bankForm.value.branch_name,
          cancelled_cheque: this.chequeImage,
        };
        registerObj = {
          username: this.signupForm.value.username,
          mobile: this.signupForm.value.mobile,
          email: this.signupForm.value.email,
          company_name: this.GSTForm.value.company_name,
          gst: (this.GSTForm.value.gst || "").trim().toUpperCase(),
          gst_verified: !!this.isGstVerified,
          designation: this.GSTForm.value.designation,
          pan: (this.GSTForm.value.pan || "").trim().toUpperCase(),
          pan_verified: !!this.isPanVerified,
          profile_pic: this.profileImage,
          account_details: bankObj,
        };
      }
      this.services
        .newRegister(registerObj, this.verifyData._id)
        .subscribe(
          (response: any) => {
            if (response.status == 200 || response.status == 201) {
              this.matDialogref.close();
              const authToken = response.body?.auth || response.auth;
              // Check if authToken is valid before storing
              if (authToken && typeof authToken === "string" && authToken.trim() !== "") {
                sessionStorage.setItem("to_token", authToken);
              }
              this.snackBar.open(
                response.body?.message ||
                  "Thanks for joining with us once admin approved you can start.",
                "Success",
                {
                  duration: 5000,
                }
              );
              this.login = true;
            } else {
              const errorMessage =
                response.body?.message ||
                response.body?.error ||
                "Registration failed. Please try again.";
              this.snackBar.open(errorMessage, "Fail", {
                duration: 5000,
              });
            }
          },
          (error: any) => {
            const errorMessage =
              error?.error?.message ||
              error?.error?.error ||
              error?.message ||
              "Registration failed. Please try again.";
            this.snackBar.open(errorMessage, "Fail", {
              duration: 5000,
            });
          }
        );
    } else {
      this.bankForm.markAllAsTouched();
      let errorMessage = "Please Fill All Mandatory Fields Details";
      if (!this.chequeImage) {
        errorMessage = "Please upload cancelled cheque";
      } else if (this.bankForm.controls['accountr_number'].invalid) {
        errorMessage = "Please enter a valid account number";
      }
      this.snackBar.open(errorMessage, "Fail", { duration: 5000 });
    }
  }
  Next() {
    if (this.signupForm.valid) {
      this.signUp = false;
      this.gst = true;
    } else {
      this.signupForm.markAllAsTouched();
      if (this.signupForm.controls['email'].hasError('pattern')) {
        this.snackBar.open("Please Enter Valid Email Format", "Fail", { duration: 5000 });
      } else if (this.signupForm.controls['username'].invalid) {
        this.snackBar.open("Please Enter Valid Name", "Fail", { duration: 5000 });
      } else if (this.signupForm.controls['mobile'].invalid) {
        this.snackBar.open("Please Enter Valid Mobile Number", "Fail", { duration: 5000 });
      } else {
        this.snackBar.open("Please Fill All Mandatory Fields Details", "Fail", { duration: 5000 });
      }
    }
  }
  onGstChange(): void {
    if (this.isGstVerified) {
      this.isGstVerified = false;
      this.gstVerificationData = null;
      this.isPanVerified = false;
      this.panVerificationData = null;
    }
  }

  editGst(): void {
    this.isGstVerified = false;
    this.gstVerificationData = null;
    this.isPanVerified = false;
    this.panVerificationData = null;
  }

  onPanChange(): void {
    const rawPan = (this.GSTForm.controls['pan']?.value || "").trim().toUpperCase();
    const cleanGst = (this.GSTForm.controls['gst']?.value || "").trim().toUpperCase();
    const panFromGst = cleanGst.length === 15 ? cleanGst.substring(2, 12) : "";

    // If user edited PAN manually and it differs from verified GST PAN, reset PAN verified flag
    if (this.isPanVerified && (!this.isGstVerified || rawPan !== panFromGst)) {
      this.isPanVerified = false;
      this.panVerificationData = null;
    }
  }

  verifyGST(rawGst?: any, callback?: () => void): void {
    const gstValue = typeof rawGst === "string" ? rawGst : this.GSTForm.controls["gst"]?.value;
    if (!gstValue || typeof gstValue !== "string" || gstValue.trim() === "") {
      this.snackBar.open("Please enter a GSTIN to verify", "OK", {
        duration: 4000,
      });
      this.GSTForm.controls["gst"]?.markAsTouched();
      return;
    }

    const cleanGst = gstValue.replace(/[^A-Za-z0-9]/g, "").trim().toUpperCase();
    if (cleanGst.length !== 15) {
      this.snackBar.open("GSTIN must be exactly 15 alphanumeric characters", "OK", {
        duration: 4000,
      });
      return;
    }

    this.token = this.token || sessionStorage.getItem("to_token") || "";
    this.isGstVerifying = true;
    this.services.verifyGST(cleanGst, this.token).subscribe({
      next: (response: any) => {
        this.isGstVerifying = false;
        let resData = response.body?.data || response.body;

        while (
          resData?.data &&
          typeof resData.data === "object" &&
          !resData.lgnm &&
          !resData.tradeNam &&
          !Array.isArray(resData.data)
        ) {
          resData = resData.data;
        }

        if (
          response.body?.success === false ||
          response.body?.gst_verified === false ||
          resData?.error === true ||
          resData?.error === "true" ||
          resData?.code === "400" ||
          resData?.code === 5004 ||
          resData?.code === "5004"
        ) {
          const errMsg =
            response.body?.message ||
            (typeof resData?.data === "string" ? resData.data : "") ||
            resData?.message ||
            "Invalid or unverified GSTIN.";
          this.snackBar.open(errMsg, "Fail", { duration: 5000 });
          this.isGstVerified = false;
          return;
        }

        const taxpayerList = Array.isArray(resData?.data)
          ? resData.data
          : Array.isArray(resData)
          ? resData
          : null;
        const taxpayer = taxpayerList
          ? taxpayerList[0]
          : resData?.data || resData;

        if (
          !taxpayer ||
          (!taxpayer.lgnm && !taxpayer.tradeNam && !taxpayer.gstin)
        ) {
          this.snackBar.open("GST details not found for this GSTIN.", "Fail", {
            duration: 5000,
          });
          this.isGstVerified = false;
          return;
        }

        this.isGstVerified = true;
        this.gstVerificationData = taxpayer;
        this.GSTForm.controls['gst'].setValue(cleanGst);

        // Auto-extract and populate PAN from GST (characters 3-12 of GSTIN)
        const panFromGst = cleanGst.length === 15 ? cleanGst.substring(2, 12) : "";
        if (panFromGst) {
          this.GSTForm.controls['pan'].setValue(panFromGst);
          this.isPanVerified = true;
        }

        // Auto-fill company name
        const businessName = (taxpayer.tradeNam || taxpayer.lgnm || "").trim();
        if (businessName) {
          this.GSTForm.controls['company_name'].setValue(businessName);
        }

        const nameMsg = businessName ? ` (${businessName})` : "";
        this.snackBar.open(`GSTIN Verified Successfully${nameMsg}!`, "Success", {
          duration: 5000,
        });

        if (callback) {
          callback();
        }
      },
      error: (error: any) => {
        this.isGstVerifying = false;
        this.isGstVerified = false;
        const errObj = error.error;
        const errMsg =
          errObj?.message ||
          (typeof errObj?.data === "string" ? errObj.data : "") ||
          (typeof errObj?.data?.data === "string" ? errObj.data.data : "") ||
          errObj?.data?.message ||
          error.message ||
          "GST verification failed. Please try again.";
        this.snackBar.open(errMsg, "Fail", { duration: 5000 });
      },
    });
  }

  verifyPAN(rawPan?: any, callback?: () => void): void {
    const panValue = typeof rawPan === "string" ? rawPan : this.GSTForm.controls["pan"]?.value;
    if (!panValue || typeof panValue !== "string" || panValue.trim() === "") {
      this.snackBar.open("Please enter a PAN to verify", "OK", {
        duration: 4000,
      });
      this.GSTForm.controls["pan"]?.markAsTouched();
      return;
    }

    const cleanPan = panValue.replace(/[^A-Za-z0-9]/g, "").trim().toUpperCase();
    if (cleanPan.length !== 10) {
      this.snackBar.open("PAN must be exactly 10 alphanumeric characters", "OK", {
        duration: 4000,
      });
      return;
    }

    this.token = this.token || sessionStorage.getItem("to_token") || "";
    this.isPanVerifying = true;
    this.services.verifyPAN(cleanPan, this.token).subscribe({
      next: (response: any) => {
        this.isPanVerifying = false;
        let resData = response.body?.data || response.body;

        while (
          resData?.data &&
          typeof resData.data === "object" &&
          !resData.lgnm &&
          !resData.tradeNam &&
          !resData.name &&
          !Array.isArray(resData.data)
        ) {
          resData = resData.data;
        }

        if (
          response.body?.success === false ||
          response.body?.pan_verified === false ||
          resData?.error === true ||
          resData?.error === "true" ||
          resData?.code === "400"
        ) {
          const errMsg =
            response.body?.message ||
            (typeof resData?.data === "string" ? resData.data : "") ||
            resData?.message ||
            "Invalid or unverified PAN.";
          this.snackBar.open(errMsg, "Fail", { duration: 5000 });
          this.isPanVerified = false;
          return;
        }

        this.isPanVerified = true;
        this.panVerificationData = resData;
        this.GSTForm.controls['pan'].setValue(cleanPan);

        const records = Array.isArray(resData?.data)
          ? resData.data
          : Array.isArray(resData)
          ? resData
          : null;
        const firstRecord = records ? records[0] : resData?.data || resData;
        const name = (firstRecord?.tradeNam || firstRecord?.lgnm || firstRecord?.name || "").trim();
        if (name && !this.GSTForm.controls['company_name'].value) {
          this.GSTForm.controls['company_name'].setValue(name);
        }

        const nameMsg = name ? ` (${name})` : "";
        this.snackBar.open(`PAN Verified Successfully${nameMsg}!`, "Success", {
          duration: 5000,
        });

        if (callback) {
          callback();
        }
      },
      error: (error: any) => {
        this.isPanVerifying = false;
        this.isPanVerified = false;
        const errObj = error.error;
        const errMsg =
          errObj?.message ||
          (typeof errObj?.data === "string" ? errObj.data : "") ||
          (typeof errObj?.data?.data === "string" ? errObj.data.data : "") ||
          errObj?.data?.message ||
          error.message ||
          "PAN verification failed. Please try again.";
        this.snackBar.open(errMsg, "Fail", { duration: 5000 });
      },
    });
  }

  skipGst() {
    this.goToBankStep();
  }

  goToBankStep() {
    this.signUp = false;
    this.gst = false;
    this.bank = true;
  }

  banksForm(isSkip?: boolean) {
    if (isSkip === true) {
      this.goToBankStep();
      return;
    }

    if (!this.GSTForm.valid) {
      this.GSTForm.markAllAsTouched();
      if (this.GSTForm.controls['company_name']?.hasError?.('pattern')) {
        this.snackBar.open("Please Enter Valid Company Name", "Fail", { duration: 5000 });
      } else if (this.GSTForm.controls['pan']?.invalid) {
        this.snackBar.open("Please Enter Valid Pan Number", "Fail", { duration: 5000 });
      } else if (this.GSTForm.controls['gst']?.invalid) {
        this.snackBar.open("Please Enter Valid GST NO", "Fail", { duration: 5000 });
      } else {
        this.snackBar.open("Please Enter Valid Details", "Fail", { duration: 5000 });
      }
      return;
    }

    const rawGst = (this.GSTForm.controls['gst']?.value || "").trim().toUpperCase();
    const rawPan = (this.GSTForm.controls['pan']?.value || "").trim().toUpperCase();

    // If GST is provided and not yet verified, auto-verify it first before moving forward
    if (rawGst && rawGst.length === 15 && !this.isGstVerified) {
      if (this.isGstVerifying) return;
      this.verifyGST(rawGst, () => {
        this.goToBankStep();
      });
      return;
    }

    // If GST is not provided, but PAN is provided and not yet verified, auto-verify PAN before moving forward
    if (!rawGst && rawPan && rawPan.length === 10 && !this.isPanVerified) {
      if (this.isPanVerifying) return;
      this.verifyPAN(rawPan, () => {
        this.goToBankStep();
      });
      return;
    }

    this.goToBankStep();
  }

  backToGst() {
    this.bank = false;
    this.gst = true;
  }

  backToSignUp() {
    this.gst = false;
    this.signUp = true;
  }

  onOtpChange(code: string): void {
    if (code.length == 4) {
      this.verifyOtp(code);
    }
  }

  resendOTP() {
    const loginData = {
      mobile: this.loginForm.value.mobile,
      user_type: "truckowner",
    };
    this.services.transporterLogin(loginData).subscribe((response: any) => {
      this.loginResponse = response;
      this.login = false;
      this.otp = true;
    });
  }

  public onChange(event: any): void {
    this.file = event.target.files[0];
    this.services.uploadImage(this.file).subscribe((response: any) => {
      if (response.status === 201) {
        this.profileImage = response.body.image_link;
        this.profileImg = false;
      }
    });
  }

  public onChequeChange(event: any): void {
    const file = event.target.files[0];
    this.services.uploadImage(file).subscribe((response: any) => {
      if (response.status === 201) {
        this.chequeImage = response.body.image_link;
        this.chequeImg = false;
        this.bankForm.controls['cancelled_cheque'].setValue(this.chequeImage);
      }
    });
  }
  newLogin() {
    this.login = true;
    this.retrieve_acc = false;
  }
  restoreAccount() {
    const userType = "active";
    this.services
      .accountRestore(userType, this.loginForm.value.mobile)
      .subscribe((response: any) => {
        this.login = true;
        this.retrieve_acc = false;
        this.snackBar.open(
          "Your account has been activated successfully",
          "Success",
          {
            duration: 5000,
          }
        );
      });
  }
  validateNumber(event: KeyboardEvent) {
    const input = String.fromCharCode(event.keyCode);
    if (!/[0-9]/.test(input)) {
      event.preventDefault();
    }
  }
}
